// extracted by mini-css-extract-plugin
export default {"indicator":"Indicator_indicator__kQf1S","point":"Indicator_point__Ry+-v","actual":"Indicator_actual__rK+xj"};